// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"Label__srOnly--20LI_","hiddenInput":"Label__hiddenInput--3H1Iy","root":"Label__root--R3iqx","hidden":"Label__hidden--3LbTQ"};